<div class="na-templates-dialog">
  <div mat-dialog-title oneDialogTitle>
    <span i18n="@@input-dialog-example.title">Send notification to additional recipients</span>
    <p i18n="@@input-dialog-example.patient-name">By clicking on “Send notification”, the additional recipients will be added to the existing recipients list and the notification will be sent to the newly added recipients.</p>
    <p class="rcp-error-msg" *ngIf="isWarn">Please remove the duplicate contacts
      <span title="Duplicate recipient warning" style="height: 24px;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" style="width: 24px; vertical-align: sub;"><path fill="#D0342C" d="M21.912 20.173L12.813 3.478c-.265-.442-.795-.618-1.237-.353a.69.69 0 0 0-.353.353L2.125 20.173c-.265.442-.089.972.353 1.237.088.088.265.088.442.088h18.197c.53 0 .883-.441.883-.883 0-.177 0-.265-.088-.442zm-9.01-2.208h-1.767v-1.767H12.9v1.767zm0-3.534h-1.767v-5.3H12.9v5.3z"></path></svg>
      </span>.
    </p>
    <p class="rcp-error-msg" *ngIf="isLimit">The maximum number of contacts is {{contactLimitNumber}}. Limit exceeded by {{excessList}}
      <span title="Duplicate recipient warning" style="height: 24px;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" style="width: 24px; vertical-align: sub;"><path fill="#D0342C" d="M21.912 20.173L12.813 3.478c-.265-.442-.795-.618-1.237-.353a.69.69 0 0 0-.353.353L2.125 20.173c-.265.442-.089.972.353 1.237.088.088.265.088.442.088h18.197c.53 0 .883-.441.883-.883 0-.177 0-.265-.088-.442zm-9.01-2.208h-1.767v-1.767H12.9v1.767zm0-3.534h-1.767v-5.3H12.9v5.3z"></path></svg>
      </span>.
    </p>
  </div>
  <div mat-dialog-content oneDialogContent class="import-dialog-content">
    <dl-notification-add-recipients-template [contactList]="contactList"  [isNewFromTemplate]="isNewFromTemplate" [addRowData]="newFeedbackOption" [displayedColumns]="templateColumn" [tableData]="templateData" [isDeleteDisabledCheck]="isDeleteDisabledCheck_dialog" *ngIf="templateData.length > 0" (isFeedbackOptionAdded)="feedbackOptionAdded($event)" (isFoRowSelected)="getSelectedRowInTemplate($event)" (isRecipientAdded)="getTableData($event)"></dl-notification-add-recipients-template>
  </div>
  <div mat-dialog-actions oneDialogActions class="na-dialog-actions" style="display:flex">
    <div>
      <!-- [disabled]="isAffBtnDisabled" [mat-dialog-close]="data"-->
    <button color="primary" [disabled]="isDeleteDisabled"  mat-flat-button i18n="@@input-dialog-example.ok-btn" (click)="deleteRows()" >
      Delete
    </button>
  </div>
    <div class="na-dialog-actions-item">
    <button
      one-secondary-button
      mat-stroked-button     
       [mat-dialog-close]="true"
       (click)="cancelClicked()"
    > Cancel
    </button>
   
    <div class="na-dropdown-button">
      <mat-action-list *ngIf="isAddRecipientBtnExpanded" oneList> <!-- *ngIf="isAfoBtnExpanded"-->
          <button (click)="manualAddRecipientClicked()" mat-list-item>Manually add recipient</button> <!--click-->
          <mat-divider></mat-divider>
          <button (click)="contactListImportClicked()" mat-list-item>Import from file</button>
          <mat-divider></mat-divider>
          <button (click)="contactListFromRexisSap()" mat-list-item>Import from Rexis/SAP</button>
          <mat-divider></mat-divider>
      </mat-action-list>
      <button (click)="addRecipientClicked()" [disabled]="isAddRecipientBtnDisabled" [class.btn-expanded]="isAddRecipientBtnExpanded" class="btn-add-recipient" mat-stroked-button one-secondary-button>
        <span>Add recipients</span>
    </button>
  </div>
  <!-- [mat-dialog-close]="data" -->
    <button color="primary" [disabled]="isSendNotificationDisabled || isLimitDis || isWarnDis"  mat-flat-button i18n="@@input-dialog-example.ok-btn" (click)="sendNotificationCall()" >
      Send notification
    </button>
  </div>
  </div>
</div>

<ng-template #EmptyContactTemplate>
  <div class="emptyRecipientAlertDialog">
    <!-- <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix >warning</mat-icon> -->
    <b>Recipient list upload is not possible.</b>
    <p>For the following recipients the email address is missing. Please correct the data and upload it again.</p>
    <table cellpadding="6px">
      <thead>
        <th>Row Index</th>
        <th>Customer Id</th>
        <th>Customer Name</th>
        <th>Customer Contact Name</th>
      </thead>
      <tbody>
        <tr *ngFor="let recipient of emptyContactList.emptyDataRow">
          <td>{{ recipient.rowIndex }}</td>
          <td>{{ recipient.customerId }}</td>
          <td>{{ recipient.customerName }}</td>
          <td>{{ recipient.customerContactName }}</td>
        </tr>
      </tbody>
    </table>
    <div class="emptyDialogCloseDiv">
      <button color="primary" mat-flat-button i18n="@@input-dialog-example.ok-btn" (click)="closeEmptyAlertDialog()" >
        Ok
      </button>
    </div>

  </div>
</ng-template>
